<template>
  <div class="invoice">
    <template v-if="!isLoading && invoice != null">
      <div class="invoice__header">
        <span @click="print" class="noprint">Print <img src="/img/adxicon/ic-print@2x.png" alt=""></span>
      </div>
      <div class="invoice__top">
        <div class="invoice__top__head_section">
          <div class="invoice__top__head_section__narada">
            <div class="invoice__top__head_section__narada__img">
              <a href="/"><img src="/img/adx/adx-red.png" alt=""></a>
            </div>
            <div class="invoice__top__head_section__narada__detail">
              <p class="name subhead strong">PT. Narada Sahara Kencana</p>
              <p class="npwp subhead">80.351.501.4-407.000</p>
              <p class="address subhead">Muara Karang Block D 7 B No.46 Jakarta Utara</p>
              <p class="phone subhead">P : 021 - 6614822</p>
              <p class="email subhead">E : support@adxasia.co.id</p>
              <span class="website"><a class="subhead" href="/">www.adxasia.co.id</a></span>
            </div>
          </div>
          <div class="invoice__top__head_section__invoice_info">
            <h2 class="invoice__top__head_section__invoice_info__title small-title">Invoice</h2>
            <div class="invoice__top__head_section__invoice_info__id">
              <span class="subtitle subhead">Invoice ID</span>
              <span class="divider">:</span>
              <span class="value subhead">{{ invoice.number }}</span>
            </div>
            <div class="invoice__top__head_section__invoice_info__order">
              <span class="subtitle subhead">Order ID</span>
              <span class="divider">:</span>
              <span class="value subhead">{{ invoice.order }}</span>
            </div>
            <div class="invoice__top__head_section__invoice_info__date">
              <span class="subtitle subhead">Invoice Date</span>
              <span class="divider">:</span>
              <span class="value subhead">{{ invoice.date }}</span>
            </div>
            <div class="invoice__top__head_section__invoice_info__payment">
              <span class="subtitle subhead">Payment method</span>
              <span class="divider">:</span>
              <span class="value subhead">{{ displayPayment(invoice.payment) }}</span>
            </div>
          </div>
        </div>
        <div class="invoice__top__main_section">
          <div class="invoice__top__main_section__bill">
            <h2 class="invoice__top__main_section__bill__subtitle subhead strong">Bill to : </h2>
            <div class="invoice__top__main_section__bill__name">
              <span class="subtitle subhead">Name</span>
              <span class="divider">:</span>
              <span class="value subhead">{{ invoice.user.full_name }}</span>
            </div>
            <div class="invoice__top__main_section__bill__phone">
              <span class="subtitle subhead">Phone</span>
              <span class="divider">:</span>
              <span class="value subhead">+{{ invoice.user.phone }}</span>
            </div>
            <div class="invoice__top__main_section__bill__email">
              <span class="subtitle subhead">Email</span>
              <span class="divider">:</span>
              <span class="value subhead">{{ invoice.user.email }}</span>
            </div>
            <div class="invoice__top__main_section__bill__address">
              <span class="subtitle subhead">Address</span>
              <span class="divider">:</span>
              <span class="value subhead">{{ invoice.user.address }}</span>
            </div>
            <div class="invoice__top__main_section__bill__company">
              <span class="subtitle subhead">Company name</span>
              <span class="divider">:</span>
              <span class="value subhead">{{ invoice.user.company }}</span>
            </div>
          </div>
          <div class="invoice__top__main_section__payment">
            <div class="invoice__top__main_section__payment__status">
              <span class="block status-title subhead">Payment status : </span>
              <span class="block status small-title strong" :class="getColor(invoice.status)">{{displayStatus(invoice.status) | capitalizing}}</span>
            </div>
            <div class="invoice__top__main_section__payment__due_date">
              <span class="block due-date-title subhead">Please complete this payment before :</span>
              <span class="block due-date strong subhead">{{ displayDueDate(invoice.due_date) }}</span>
            </div>
          </div>
        </div>
        <div class="invoice__top__campaign_section">
          <div class="invoice__top__campaign_section__left">
            <h2 class="invoice__top__campaign_section__left__subtitle subhead">Media placement</h2>
            <div class="invoice__top__campaign_section__left__info">
              <span class="subtitle subhead">Campaign name</span>
              <span class="divider">:</span>
              <span class="value subhead">{{ invoice.campaign.title }}</span>
            </div>
            <div class="invoice__top__campaign_section__left__info">
              <span class="subtitle subhead">Campaign period</span>
              <span class="divider">:</span>
              <span class="value subhead">{{ displayPeriod(invoice.campaign.start, invoice.campaign.end) }}</span>
            </div>
            <div class="invoice__top__campaign_section__left__info">
              <span class="subtitle subhead">Ads duration</span>
              <span class="divider">:</span>
              <span class="value subhead">{{ invoice.campaign.duration }} seconds</span>
            </div>
          </div>
          <div class="invoice__top__campaign_section__right">
            <div class="invoice__top__campaign_section__right__price">
              <span class="rp strong">Rp</span>
              <span class="strong">{{ formatPrice(invoice.before_tax_price) }}</span>
            </div>
          </div>
        </div>
        <div class="invoice__top__total_section">
          <div class="invoice__top__total_section__total_box">
            <div class="invoice__top__total_section__total_box__subtotal">
              <span class="subtitle subhead">Subtotal</span>
              <div class="price">
                <span class="rp subhead">Rp</span>
                <span class="nominal subhead">{{ formatPrice(invoice.before_tax_price) }}</span>
              </div>
            </div>
            <div class="invoice__top__total_section__total_box__tax">
              <span class="subtitle subhead">PPN 10%</span>
              <div class="price">
                <span class="rp subhead">Rp</span>
                <span class="nominal subhead">{{ formatPrice(invoice.tax_price) }}</span>
              </div>
            </div>
            <div v-if="invoice.discount > 0" class="invoice__top__total_section__total_box__discount">
              <span class="subtitle subhead">Discount</span>
              <div class="price">
                <span class="rp subhead">- Rp</span>
                <span class="nominal subhead">{{ formatPrice(invoice.discount) }}</span>
              </div>
            </div>
            <div v-if="invoice.balance > 0" class="invoice__top__total_section__total_box__discount">
              <span class="subtitle subhead">ADX Balance</span>
              <div class="price">
                <span class="rp subhead">- Rp</span>
                <span class="nominal subhead">{{ formatPrice(invoice.balance) }}</span>
              </div>
            </div>
            <div class="invoice__top__total_section__total_box__total">
              <span class="subtitle strong large-font">Total</span>
              <div class="price">
                <span class="rp strong large-font">Rp</span>
                <span class="nominal strong large-font">{{ formatPrice(invoice.net_price) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="invoice__devices">
        <div class="invoice__devices__header">
          <div class="invoice__devices__header__logo">
            <a href="/"><img class="logo" src="/img/adx/adx-red.png" alt=""></a>
          </div>
          <div class="invoice__devices__header__invoice">
            <span class="subtitle subhead">Invoice ID</span>
            <span>:</span>
            <span class="value subhead">{{ invoice.number }}</span>
          </div>
        </div>
        <table class="table-devices">
          <thead>
            <th class="no">No</th>
            <th class="items">Items</th>
            <th class="price">Price / Day</th>
            <th class="days">Days</th>
            <th class="total">Total</th>
          </thead>
          <tbody>
            <tr v-for="(device, index) in invoice.devices" :key="device.id">
              <td class="no">{{index + 1}}</td>
              <td>{{ device.location }}</td>
              <td>
                <div class="space">
                  <span class="subhead">Rp</span>
                  <span class="subhead">{{ formatPrice(device.price) }}</span>
                </div>
              </td>
              <td>{{ device.days }}</td>
              <td>
                <div class="space">
                  <span class="subhead">Rp</span>
                  <span class="subhead">{{ formatPrice(device.total) }}</span>
                </div>
              </td>
            </tr>
            <tr class="no-border">
              <td colspan="3"></td>
              <td>Subtotal</td>
              <td>
                <div class="space">
                  <span class="subhead">Rp</span>
                  <span class="subhead">{{ formatPrice(invoice.before_tax_price) }}</span>
                </div>
              </td>
            </tr>
            <tr class="no-border">
              <td colspan="3"></td>
              <td>PPN 10%</td>
              <td>
                <div class="space">
                  <span class="subhead">Rp</span>
                  <span class="subhead">{{ formatPrice(invoice.tax_price) }}</span>
                </div>
              </td>
            </tr>
            <tr v-if="invoice.discount > 0" class="no-border">
              <td colspan="3"></td>
              <td>Discount</td>
              <td>
                <div class="space">
                  <span class="subhead">Rp</span>
                  <span class="subhead">{{ formatPrice(invoice.discount) }}</span>
                </div>
              </td>
            </tr>
            <tr class="total no-border">
              <td colspan="3"></td>
              <td class="total-bg large-font strong">Total</td>
              <td class="total-bg">
                <div class="space">
                  <span class="large-font strong">Rp</span>
                  <span class="large-font strong">{{ formatPrice(invoice.net_price) }}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <div v-else class="invoice__loading">
      <adx-loading />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Loading from '@/components/Loading/Primary'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import lib from '@/lib/util'

export default {
  name: 'adx-transaction-invoice-anon',
  components: {
    'adx-loading': Loading,
  },
  data(){
    return {
      invoiceId: null,
      invoice: null,
      isLoading: false,
    }
  },
  beforeMount() {
    const { uid } = this.$route.params
    if (uid) {
      this.invoiceId = uid
      this.loadData()
    } else {
      this.$router.replace({ name: `404` })
    }
  },
  computed: {
  },
  methods: {
    loadData() {
      (async () => {
        this.isLoading = true
        const response = await api.get(apiV2.invoiceDetailAnon(this.invoiceId))
        if (response.status === 200) {
          this.invoice = response.data
          this.isLoading = false
        } else {
          this.$router.replace({ name: `404` })
        }
      })();
    },
    displayPeriod(start, end) {
      return `${moment(start).format('DD MMM YYYY')} - ${moment(end).format('DD MMM YYYY')}`
    },
    displayStatus(status) {
      if (status == 'wfp') {
        return 'Waiting payment'
      }

      return status
    },
    displayDueDate(date) {
      if (date) return `${moment(date).format('DD MMM YYYY, HH:mm')} WIB`
      return '-'
    },
    displayPayment(payment) {
      if (!payment) {
        return '-'
      }

      return payment
    },
    formatPrice(price) {
      if (price == 0) return 0
      let strPrice = price.toString()
      let arrayPrice = strPrice.split('')
      let revArrayPrice = arrayPrice.reverse()
      let newPrice = []
      revArrayPrice.forEach((value, index) => {
        newPrice.push(value)
        if ((index+1) % 3 == 0 && index+1 != revArrayPrice.length) {
          newPrice.push('.')
        }
      })
      return newPrice.reverse().join('')
    },
    getColor(status) {
      if(status == 'paid'){
        return 'color-green'
      }else {
        return 'status'
      }
    },
    print() {
      window.print()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>

<style lang="scss">
@media print {
  body, .container {
    height: auto;
  }

  .invoice {
    &__header {
      display: none !important;
    }

    &__top {
      display: block;
      height: auto !important;
      page-break-after: always;
      page-break-inside: avoid;

      &__head_section {
        &__narada__detail {
          p {
            font-size: 13px !important;
          }

          .website a {
            font-size: 13px !important;
          }
        }

        &__invoice_info {
          &__title {
            font-size: 17px !important;
          }

          .subtitle, .value {
            font-size: 13px !important;
          }
        }
      }

      &__main_section {
        &__bill {
          &__subtitle {
            font-size: 13px !important;
          }

          .subtitle, .value {
            font-size: 13px !important;
          }
        }
        &__payment {
          &__status {
            span {
              font-size: 13px !important;
            }

            .status {
              font-size: 17px !important;
            }
          }

          &__due_date {
            span {
              font-size: 13px !important;
            }
          }
        }
      }

      &__campaign_section {
        &__left {
          &__subtitle {
            font-size: 13px !important;
          }
          .subtitle, .value {
            font-size: 13px !important;
          }
        }

        &__right {
          &__price {
            span {
              font-size: 15px !important;
            }
          }
        }
      }

      &__total_section {
        &__total_box {
          &__subtotal, &__discount,
          &__tax, &__total {
            .subtitle {
              font-size: 13px !important;
            }

            .price span {
              font-size: 13px !important;
            }
          }

          &__total {
            .subtitle {
              font-size: 15px !important;
            }

            .price span {
              font-size: 15px !important;
            }
          }
        }
      }
    }

    &__devices {
      margin-top: 16px;

      &__total_section {
        &__total_box {
          &__subtotal, &__discount,
          &__tax, &__total {
            .subtitle {
              font-size: 13px !important;
            }

            .price {
              font-size: 13px !important;

              span {
                font-size: 13px !important;
              }
            }
          }

          &__total {
            .subtitle {
              font-size: 15px !important;
            }

            .price span {
              font-size: 15px !important;
            }
          }
        }
      }
    }
  }

  .table-devices {
    th {
      font-size: 13px !important;
    }

    td {
      padding: 8px 16px !important;
      font-size: 13px !important;

      .space span {
        font-size: 13px !important;
      }
    }
  }
}

@page {
  size: A4 portrait;
  counter-increment: page;
}

</style>
